import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, url, image }) => {
  const metaTitle = title || 'Keyif';
  const metaDescription = description || 'Keyif platform blog and profiles.';
  const metaUrl = url || window.location.href;
  const metaImage = image || '';

  return (
    <Helmet>
      <title>{metaTitle}</title>
      {metaDescription && (
        <meta name="description" content={metaDescription} />
      )}
      <meta property="og:title" content={metaTitle} />
      {metaDescription && (
        <meta property="og:description" content={metaDescription} />
      )}
      {metaUrl && <meta property="og:url" content={metaUrl} />}
      {metaImage && <meta property="og:image" content={metaImage} />}
    </Helmet>
  );
};

export default SEO;
